const ddBtns = document.querySelectorAll('.nst-menu-btn > .nst-menu-link');

const toggleDd = function () {
    const thisMain = this.parentElement;

        let menuBtns = Array.from(thisMain.children);
        if(this.parentElement.classList.contains('nst-menu-main-link')) {
            menuBtns = ddBtns;
        } else if (this.parentElement.classList.contains('nst-menu-dl-link')) {
            menuBtns = Array.from(thisMain.parentElement.children);
        }
      
    if(thisMain.classList.contains('rdc-active')) {
        
        thisMain.classList.remove('rdc-active');
    } else {
        menuBtns.forEach(ddBtn => {
            if (this.parentElement.classList.contains('nst-menu-dl-link')) {
                ddBtn.classList.remove('rdc-active'); 
            } else {
                ddBtn.parentElement.classList.remove('rdc-active');
            }
            
        });
        thisMain.classList.add('rdc-active');
    }
}

ddBtns.forEach(ddBtn => {
    ddBtn.addEventListener('click',toggleDd);
});
